/* SYSTEM PAGES */
import BlankRouteViewer from '@/views/system/blankRouteViewer.vue'
import ClientRouteViewer from '@/views/system/clientRouteViewer.vue'
import NotAuthorized from '@/views/system/notAuthorized.vue'
import NotFound from '@/views/system/notFound.vue'
import NotYetImplemented from '@/views/system/notYetImplemented.vue'
import RedirectToHome from '@/views/system/redirectToHome.vue'
import StyleGuide from '@/views/style-guide/style-guide.vue'
import UnknownUser from '@/views/system/unknownUser.vue'

/* AUTHENTICATION PAGES */
import Login from '@/views/auth/index.vue'
import ForgotPassword from '@/views/auth/forgotPassword.vue'
import Register from '@/views/auth/register.vue'

/* ADMINISTRATION PAGES */
// TBD

/* CHECK IN/OUT PAGES */
import CheckIn from '@/views/check/in/index.vue'
import CheckInClient from '@/views/check/in/checkInClient.vue'

/* CLIENT PAGES */
// TBD

/* DASHBOARD PAGES */
// TBD

/* TECH PAGES */
// TBD

/* LOCATION PAGES */
// TBD

export default [
  // auth
  {
    path: '/',
    component: Login,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: '/register',
    component: Register,
    meta: {
      hideNavigation: true
    }
  },

  // administration
  {
    path: '/administration',
    component: BlankRouteViewer,
    meta: {
      requiredAuth: 'canAdmin'
    },
    children: [
      {
        path: '',
        component: NotYetImplemented
      },
      {
        path: 'company',
        component: NotYetImplemented
      },
      {
        path: 'techs',
        component: NotYetImplemented,
        children: [
          {
            path: ':id',
            component: NotYetImplemented
          }
        ]
      },
      {
        path: 'locations',
        component: NotYetImplemented,
        children: [
          {
            path: ':id',
            component: NotYetImplemented
          }
        ]
      }
    ]
  },

  // checkout and checkin
  {
    path: '/check',
    component: BlankRouteViewer,
    children: [
      {
        path: '',
        component: RedirectToHome
      },
      {
        path: 'out',
        component: NotYetImplemented
      },
      {
        path: 'in',
        component: ClientRouteViewer,
        meta: {
          hideNavigation: true,
          requiredAuth: 'canCheckIn'
        },
        children: [
          {
            path: '',
            component: CheckIn,
            meta: {
              hideNavigation: true
            }
          },
          {
            path: 'client',
            component: CheckInClient,
            meta: {
              hideNavigation: true
            }
          }
        ]
      }
    ]
  },

  // client
  {
    path: '/clients',
    component: BlankRouteViewer,
    children: [
      {
        path: '',
        component: NotYetImplemented
      },
      {
        path: ':id',
        component: NotYetImplemented
      }
    ]
  },

  // dashboard
  {
    path: '/dashboard',
    component: BlankRouteViewer,
    children: [
      {
        path: '',
        component: NotYetImplemented
      },
      {
        path: 'weekly',
        component: NotYetImplemented
      }
    ]
  },

  // location stats
  {
    path: '/location-stats',
    component: NotYetImplemented
  },

  // tech
  {
    path: '/tech',
    component: BlankRouteViewer,
    meta: {
      requiredAuth: 'canTech'
    },
    children: [
      {
        path: '',
        component: NotYetImplemented
      },
      {
        path: 'kut',
        component: NotYetImplemented
      },
      {
        path: 'profile',
        component: NotYetImplemented
      }
    ]
  },

  // style guide for development
  {
    path: '/style-guide',
    component: StyleGuide,
    meta: {
      hideNavigation: true
    }
  },

  // system
  {
    path: '/not-authorized',
    component: NotAuthorized,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: '/user',
    component: UnknownUser,
    meta: {
      hideNavigation: true
    }
  },

  // 404 page
  {
    path: '*',
    component: NotFound,
    meta: {
      hideNavigation: true
    }
  }
]
